import React, { useState } from 'react'
import { firestore } from '../../../../firebase';

function SingleDetailEdit({detail}) {
    
    const [description, setDescription] = useState(detail.description);
    const [image, setImage] = useState(detail.image);
    const [link, setLink] = useState(detail.link);
    const [subtitle, setSubtitle] = useState(detail.subtitle);
    const [title, setTitle] = useState(detail.title);

    const [type, setType] = useState(detail.type);

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    
    const [show, setShow] = useState(false);

    async function editHandler(e) {
        e.preventDefault();
        try {
            const detailsRef = firestore.collection("site_details").doc("X0LJ5z6LWL0qF8AluQLA").collection("home_cards").doc(detail.id);
            
            const data = {
                title, 
                description,
                image,
                link,
                subtitle,
                type

            }
            detailsRef.update(data);
            setMessage("Oppdatert")
        } catch (error) {
            setError("Kunne ikke oppdatere");
        }
        
    }

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }
    }

    return (
        <React.Fragment>
            
            <div className="card card-header mt-3" onClick={toggle}>{title}</div>
            {show && (
                <form onSubmit={editHandler}>
                    <label>Tittel</label>
                    <input className="form-control mb-2" value={title} onChange={e => setTitle(e.target.value)} placeholder="Tittel" />

                    <label>Beskrivelse</label>
                    <input className="form-control mb-2" value={description} onChange={e => setDescription(e.target.value)} placeholder="Beskrivelse" />

                    <label>Bilde</label>
                    <input className="form-control mb-2" value={image} onChange={e => setImage(e.target.value)} />
                    <div className="col-lg-4 col-md-6 mx-auto">
                        <img src={image} alt="decorative image card" className="img-fluid" />
                    </div>

                    <label>Lenke</label>
                    <input className="form-control mb-2" value={link} onChange={e => setLink(e.target.value)} placeholder="Lenke" />

                    <label>Subtittel</label>
                    <input className="form-control mb-2" value={subtitle} onChange={e => setSubtitle(e.target.value)} placeholder="Subtittel" />

                    <label>Type (card / featured)</label>
                    <input className="form-control mb-2" value={type} onChange={e => setType(e.target.value)} placeholder="Type" />

                    {message && <div className="alert alert-success">{message}</div>}
                    {error && <div className="alert alert-danger">{error}</div>}
                    <button className="btn btn-block btn-success">Lagre</button>
                </form>
            )}

        </React.Fragment>

    )
}
export default SingleDetailEdit